import { render, staticRenderFns } from "./edit-passenger-modal.vue?vue&type=template&id=4ada0f9a&scoped=true"
import script from "./edit-passenger-modal.vue?vue&type=script&lang=js"
export * from "./edit-passenger-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ada0f9a",
  null
  
)

export default component.exports